var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 55H13.3065V53.2258H1.77423V23.9515H13.3065V22.1775H0V55Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6953 22.1775V23.9515H53.2276V53.2258H41.6953V55H55.0018V22.1775H41.6953Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 26.6129H4.4375V31.9354H9.76V26.6129ZM7.98577 30.1614H6.21154V28.3871H7.98577V30.1614Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 34.5967H4.4375V39.9192H9.76V34.5967ZM7.98577 38.1451H6.21154V36.3709H7.98577V38.1451Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 47.9033H9.76V42.5808H4.4375V47.9033ZM6.21154 44.3549H7.98577V46.1291H6.21154V44.3549Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5647 26.6129H45.2422V31.9354H50.5647V26.6129ZM48.7906 30.1614H47.0164V28.3871H48.7906V30.1614Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2422 39.9194H50.5647V34.5969H45.2422V39.9194ZM47.0164 36.371H48.7906V38.1452H47.0164V36.371Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2422 47.9033H50.5647V42.5808H45.2422V47.9033ZM47.0164 44.3549H48.7906V46.1291H47.0164V44.3549Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5791 54.9999H12.418V7.09668H42.5793L42.5791 54.9999Z",
    fill: "#F9BA48"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6916 1.77423V0H39.9176H39.0305H15.9658H15.0787H13.3047V1.77423H15.0787V7.98385H16.853V1.77423H38.1433V7.98385H39.9176V1.77423H41.6916Z",
    fill: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1782 11.5323H16.8555V16.8549H22.178L22.1782 11.5323ZM20.4039 15.0806H18.6297V13.3064H20.4039V15.0806Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1623 11.5323H24.8398V16.8549H30.1623V11.5323ZM28.3881 15.0806H26.6139V13.3064H28.3881V15.0806Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1469 11.5323H32.8242V16.8549H38.1467L38.1469 11.5323ZM36.3727 15.0806H34.5984V13.3064H36.3727V15.0806Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.372 39.0323H18.6301H17.743H15.9688V40.8066H17.743V55H37.2591V40.8066H39.0334V39.0323H37.2591H36.372ZM19.5172 40.8066H26.6139V44.355H25.7268C24.2596 44.355 23.0655 45.5492 23.0655 47.0164C23.0655 48.4836 24.2596 49.6777 25.7268 49.6777H26.6139V53.2262H19.5172V40.8066ZM26.6139 47.9033H25.7268C25.238 47.9033 24.8397 47.506 24.8397 47.0162C24.8397 46.5264 25.238 46.1291 25.7268 46.1291H26.6139V47.9033ZM28.3882 46.1291H29.2753C29.7641 46.1291 30.1624 46.5264 30.1624 47.0162C30.1624 47.506 29.7641 47.9033 29.2753 47.9033H28.3882V46.1291ZM35.4849 53.2258H28.3882V49.6774H29.2753C30.7425 49.6774 31.9366 48.4832 31.9366 47.016C31.9366 45.5488 30.7425 44.3547 29.2753 44.3547H28.3882V40.8062H35.4849V53.2258Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8555 24.8386H22.178V19.5161H16.8555V24.8386ZM18.6297 21.2903H20.4039V23.0646H18.6297V21.2903Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8398 24.8386H30.1623V19.5161H24.8398V24.8386ZM26.6141 21.2903H28.3883V23.0646H26.6141V21.2903Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8242 24.8386H38.1467V19.5161H32.8242V24.8386ZM34.5984 21.2903H36.3727V23.0646H34.5984V21.2903Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8555 32.8225H22.178V27.5H16.8555V32.8225ZM18.6297 29.2742H20.4039V31.0485H18.6297V29.2742Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8398 32.8225H30.1623V27.5H24.8398V32.8225ZM26.6141 29.2742H28.3883V31.0485H26.6141V29.2742Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8242 32.8225H38.1467V27.5H32.8242V32.8225ZM34.5984 29.2742H36.3727V31.0485H34.5984V29.2742Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4849 35.4839H15.9688V37.2581H35.4849V35.4839Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.032 35.4839H37.2578V37.2581H39.032V35.4839Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.4fe87589b4d6474ea3854167819dbcd4.svg";
export { ForwardRef as ReactComponent };